/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Vision UI Dashboard React Base Styles
import colors from "assets/theme/base/colors";
import bgAdmin from "assets/images/orli-bg-blue.png";

const { info, dark, light } = colors;
export default {
  html: {
    scrollBehavior: "smooth",
    background: dark.body,
    "--app-viewport-height": "100vh",
    "@supports (height: 100dvh)": {
      "--app-viewport-height": "100dvh",
    },
  },
  body: {
    // background: `url(${bgAdmin})`,
    background: light.main,
    backgroundSize: "cover",
    minHeight: "var(--app-viewport-height, 100vh)",
  },
  "#root": {
    minHeight: "var(--app-viewport-height, 100vh)",
  },
  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
  },
  "a, a:link, a:visited": {
    textDecoration: "none !important",
  },
  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    color: `${dark.main} !important`,
    transition: "color 150ms ease-in !important",
  },
  "a.link:hover, .link:hover, a.link:focus, .link:focus": {
    color: `${info.main} !important`,
  },
  input: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0px 1000px transparent inset",
      boxShadow: "0 0 0px 1000px transparent inset",
      WebkitTextFillColor: "#ffffff",

      caretColor: "inherit",
      transition: "background-color 9999s ease-in-out 0s",
    },

    "&:-webkit-autofill:hover": {
      WebkitBoxShadow: "0 0 0px 1000px transparent inset",
    },

    "&:-webkit-autofill:focus": {
      WebkitBoxShadow: "0 0 0px 1000px transparent inset",
    },
  },
};
